interface IconProps {
  image: string;
  className?: string;
}

function Icon({ image, className = '' }: IconProps): JSX.Element {
  return (
    <i className={className}>
      <style jsx>{`
        i {
          background-image: url(${image});
          background-size: cover;
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      `}</style>
    </i>
  );
}

export default Icon;
